import FormForService from "../forms/FormForService";

function CustomButton(props) {
  return (
    <div className="ms-3 me-3 text-center">
      {!props.data.product || props.data.href.slice(0, 4) === "http" ? (
        <a
          href={props.data?.href ? props.data.href : "#"}
          className="btn btn-default btn-with-link"
          style={{ color: "#FFF" }}
        >
          {props.data?.title}
        </a>
      ) : (
        <>
          {/* <a
            href={
              props.data?.href
                ? props.data.href + "?product=" + props.data.product
                : "#"
            }
            className="btn btn-default btn-with-link"
            style={{ color: "#FFF" }}
          >
            {props.data?.title}
          </a> */}
          <FormForService productId={props.data.product} />
        </>
      )}
    </div>
  );
}

const ButtonWithLink = {
  Renderer: (props) => <CustomButton {...props} />,
  id: "ButtonWithLink",
  version: "ButtonWithLink",
  title: "Button with Link",
};

export default ButtonWithLink;
